import type React from 'react'
import type { JSX } from 'react'

import { SeasonBlockHeaderSC } from './SeasonBlock.styled'

export interface ISeasonBlockHeaderProps {
  children?: React.ReactNode
  dataTestId?: string
}

export const SeasonBlockHeader = ({
  children,
  dataTestId,
}: ISeasonBlockHeaderProps): JSX.Element => (
  <SeasonBlockHeaderSC data-testid={dataTestId}>{children}</SeasonBlockHeaderSC>
)

SeasonBlockHeader.displayName = 'SeasonBlockHeader'
